import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bachelor-of-business-degree',
  templateUrl: './bachelor-of-business-degree.component.html',
  styleUrls: ['./bachelor-of-business-degree.component.scss']
})
export class BachelorOfBusinessDegreeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;
  
  ngOnInit(): void {
  }

}
